"use client";

// API
import { useState } from "react";
import Search from "@/components/input/Search/Search";
import { SubscribeModal } from "@/components/SubscribeModal";
// CUSTOM COMPONENTS
import Tab from "@/components/ui/Tab";

import { CardList } from "./CardList";

const MyCards = () => {
  const [tab, setTab] = useState<"DRAFT" | "SENT">("DRAFT");
  const [search, setSearch] = useState("");

  return (
    <div className="space-y-4 px-1.5 py-4 lg:px-8">
      {/* <SubscribeModal visible={true} hide={() => null} /> */}
      <div className="flex flex-wrap items-center justify-between space-y-4">
        <div className="justify-left flex space-x-6">
          <Tab
            text="Drafts"
            currentTab={tab}
            setValue={setTab}
            value={"DRAFT"}
          />
          <Tab
            text="Sent Cards"
            currentTab={tab}
            setValue={setTab}
            value="SENT"
          />
        </div>
        <Search />
      </div>

      <div className="grid grid-cols-2 gap-4 lg:grid-cols-3 lg:gap-8 xl:grid-cols-4 2xl:grid-cols-5 2xl:gap-x-16">
        <CardList filter={search} state={tab} />
      </div>
    </div>
  );
};

export default MyCards;
